'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ko_Kr = {
  // pay
  www_title: 'CalendarTask',
  www_homepage: '홈페이지',
  www_keywords: 'CalendarTask,캘린더,메모,일기,달력,다이어리,노트,스케줄,good note,일정,메모장,미리알림,계획,투두리스트,공휴일,음력,체크리스트,일정 관리,calender,노트쉘프,디데이,굿노트,시간표',
  www_description: '음력, 태양력, 공휴일 및 법정 공휴일을 표시하여 바탕 화면 배경 무늬에 투명하게 표시 할 수 있습니다. 상식, 일정, 반복 작업 등을 편집하고 기록하려면 두 번 클릭하십시오. 데이터의 다중 터미널 동기화, 데이터의 실시간 공유, 팀워크를 지원합니다. ',
  update_log: '',
  more_function: '추가 기능 소개',
  slogan_text1: '음력, 태양력, 공휴일 및 법정 공휴일을 표시하여 바탕 화면 배경 무늬에 투명하게 표시 할 수 있습니다. ',
  slogan_text2: '상식, 일정, 반복 작업 등을 편집하고 기록하려면 두 번 클릭하십시오. ',
  slogan_text3: '데이터의 다중 터미널 동기화, 데이터의 실시간 공유, 팀워크를 지원합니다. ',
  slogan_h5: '음력, 태양력, 공휴일 및 법정 공휴일을 표시하여 바탕 화면 배경 무늬에 투명하게 표시 할 수 있습니다. 상식, 일정, 반복 작업 등을 편집하고 기록하려면 두 번 클릭하십시오. 데이터의 다중 터미널 동기화, 데이터의 실시간 공유, 팀워크를 지원합니다.',
  android_download: '다운로드',
  ios_download: '앱스토어 설치',
  support_system: '다음 플랫폼이 지원되었습니다',
  windows_button: 'Windows 버전',
  mac_button: 'Mac 버전',
  linux_button: 'Linux 버전',
  linux_op_x86: 'X86 버전',
  linux_op_arm64: 'ARM64 버전',
  iphone_button: 'iPhone版',
  android_button: '안드로이드版',
  scan_download_phone: '모바일 버전 다운로드',
  content_title1: '실시간 데이터 동기화',
  content_text1: 'PC 컴퓨터, Mac 컴퓨터 및 휴대폰간에 실시간으로 일정을 동기화 할 수 있습니다. \ n 소규모 팀이라면 팀 공동 작업을 수행 할 수도 있습니다.',
  content_title2: '투명 디스플레이',
  content_text2: '바탕 화면에 직접 고정하고 단축키를 눌러 바탕 화면으로 돌아가 일정과 캘린더 정보를 편집하고 볼 수 있습니다.',
  content_title3: '반복 이벤트',
  content_text3: '중요 기념일, 신용 카드 상환, 수강생 과정 등 반복 작업을 설정하여 달력에 표시 가능',
  content_title4: '원하는 캘린더는 항상 있습니다',
  content_text4: '당신의 산업이 사무직 노동자, 학생, 교사, IT, 정부 기관, 금융, 강력한 달력 설정 기능은 항상 당신의 요구를 충족시킬 수 있습니다.',
  support: '고객 지원',
  support_title: 'CalendarTask-고객 지원',
  support_text1: '의견 및 제안 사항이 있으면 이메일을 보내주십시오. \n Email: service@xiaoweiyunfu.com',
  support_text2: '',
  help: '',
  pay_title: 'CalendarTask-함수 소개',
  cata_basic_intro_title: '기능 소개',
  cata_basic_intro_title1: '여러 기기 동기화 (수동)',
  basic_intro_title1: '여러 기기 동기화',
  basic_intro_subtitle1: '휴대폰, 컴퓨터, iPad 어디서든 쉽게 데이터 동기화 가능',
  basic_intro_text1: '동기화가 필요한 기기에서 동일한 계정으로 로그인. <p class="p" /><font color="#FE776D">데이터가 있는 기기에서 클라우드 버튼을 클릭하여 수동 동기화하면 다른 기기에서도 기록된 데이터가 표시됩니다. </font><p class="p" />자동 동기화 기능도 제공하고 있으니 이를 활성화하면 데이터가 자동으로 기기 간 동기화됩니다.',
  cata_basic_intro_title2: '캘린더 메모',
  basic_intro_title2: '캘린더 메모',
  basic_intro_subtitle2: '캘린더를 이용한 사소한 일 기록, 간결하면서도 유용함',
  basic_intro_text2: '캘린더에서 원하는 날짜를 더블 클릭하면 편집 창이 열리고, 기록할 수 있습니다.  <p class="p" />Enter를 눌러 줄바꿈 후 새로운 작업을 기록할 수 있습니다.',
  cata_basic_intro_title3: '알림',
  basic_intro_title3: '알림',
  basic_intro_subtitle3: '중요한 일을 놓치지 않도록 알림을 추가하여 실시간으로 리마인드.',
  basic_intro_text3: '편집 창 아래의 알림 버튼을 클릭하여 알림 추가 <p class="p" />반복 유형, 종료 날짜, 알림 횟수 및 알림 시간 등을 커스터마이징으로 설정할 수 있습니다. ',
  cata_basic_intro_title4: 'D-Day',
  basic_intro_title4: 'D-Day',
  basic_intro_subtitle4: '중요한 날짜를 잊지 않도록 디데이를 설정하여 알림',
  basic_intro_text4: '편집 창 아래의 카운트다운 버튼을 클릭하여 추가. <p class="p" />D-Day는 (생일, 명절, 기념일, 시험 및 기본) 등 다섯 가지 카테고리가 있고, 멋진 D-Day 카드로 더욱 편리한 알림을 제공합니다.',
  cata_basic_intro_title5: '작업 완료 표시',
  basic_intro_title5: '작업 완료 표시',
  basic_intro_subtitle5: '한 번의 클릭으로 작업을 완료로 체크하여, 완성한 업무에 대한 성취감 향상 ',
  basic_intro_text5: '편집 창 첫 번째 버튼을 클릭하여 완료로 표시합니다. ',
  cata_basic_intro_title6: '검색',
  basic_intro_title6: '검색',
  basic_intro_subtitle6: '검색 기능을 사용하여 이력 조회 가능',
  basic_intro_text6: '캘린더 오른쪽 상단의 화살표 버튼을 클릭하고 검색 선택.<p class="p" />검색창에 키워드를 입력하면 조건에 맞는 일정이 아래에 표시됩니다. <p class="p" />검색 결과에서 원하는 일정을 더블 클릭하면 편집 창으로 들어가 수정할 수 있습니다.',
  cata_basic_intro_title7: '반복 작업',
  basic_intro_title7: '반복 작업',
  basic_intro_subtitle7: '자주 반복되는 일정을 쉽게 설정 가능 ',
  basic_intro_text7: '편집 창에서 반복 작업 버튼을 클릭하고, 필요에 따라 반복 시간과 유형을 선택하세요.',
  cata_basic_intro_title8: '교육 주간',
  basic_intro_title8: '교육 주간',
  basic_intro_subtitle8: '학생과 교사를 위해 교육 주간을 표시하는 기능을 제공합니다. ',
  basic_intro_text8: '캘린더 오른쪽 상단의 메뉴 버튼을 클릭한 후 설정을 클릭한 후 설정 대화 상자에서 고급을 선택하고 마지막으로 현재 학기의 주 번호를 "첫 번째 주"로 설정하여 주 번호가 달력 왼쪽에는 교육 주간이 표시됩니다. ',
  cata_basic_intro_title9: '캘린더 텍스트 조정',
  basic_intro_title9: '캘린더 텍스트 조정',
  basic_intro_subtitle9: '캘린더의 시스템 텍스트의 글꼴, 크기 및 색상 설정 가능',
  basic_intro_text9: '캘린더 오른쪽 상단의 화살표 클릭한 후 설정 선택, 설정에서 \"캘린더\"를 선택하고,  글꼴 크기 및 색상을 조정할 수 있습니다.',
  cata_basic_intro_title10: '기록 내용 텍스트 조정',
  basic_intro_title10: '기록 내용 텍스트 조정',
  basic_intro_subtitle10: '셀 내의 텍스트의 글꼴, 크기 및 색상 설정 가능 ',
  basic_intro_text10: '캘린더 오른쪽 상단의 화살표 클릭한 후 설정 선택, 설정에서 \"셀\"을 선택하고,  글꼴 크기 및 색상을 조정할 수 있습니다.',

  //便签
  cata_basic_intro_title11: "메모",
  basic_intro_title11: "메모",
  basic_intro_subtitle11: "간단하고 사용하기 쉬운 메모 기능을 갖추고 있습니다.",
  basic_intro_text11: "캘린더 오른쪽 상단의 플러그인 버튼을 클릭하면 메모 관련 기능을 볼 수 있으며, 새 메모를 만들거나 메모 설정을 할 수 있습니다.",

  // 课程表
  cata_basic_intro_title12: '시간표',
  basic_intro_title12: '시간표',
  basic_intro_subtitle12: '완벽한 기능의 시간표 기능을 제공합니다.',
  basic_intro_text12: '달력 우측 상단의 플러그인 버튼을 클릭하면 시간표 기능을 확인할 수 있으며, 새로운 시간표를 생성하거나 기존 시간표를 설정할 수 있습니다.',

  // 2024-09-26 新增独家介绍
  exclusive_title: '독점',
  cata_basic_intro_new_title0: "광고 제로",
  basic_intro_new_subtitle0: "광고가 없는 것이 진정한 효율성",
  basic_intro_new_text0: "유료 사용자든 무료 사용자든, 어떤 플랫폼에서 작업하든, 갤린더 타스크는 어떤 광고의 방해도 받지 않고 순수하게 제공됩니다.",

  cata_basic_intro_new_title1: "투명하게 바탕화면에 고정",
  basic_intro_new_subtitle1: "시스템 또는 배경화면과 완벽하게 통합",
  basic_intro_new_text1: "갤린더를 사용하면서 파일 또는 아이콘 클릭 등 마우스 이용이 자유롭게 진행됩니다. ",

  cata_basic_intro_new_title2: " 이월 표시 ( 월별 사용자 정의 )",
  basic_intro_new_subtitle2: "월 초나 월 말에 상관없이, 앞뒤로 1~2주의 일정 확인할",
  basic_intro_new_text2: "캘린더 오른쪽 상단의 화살표를 클릭하고, 설정에서 \"캘린더 - 월별\"에서 이월 표시 또는 고정 월별 표시를 선택할 수 있습니다.",

  cata_basic_intro_new_title3: "휴일 숨기기",
  basic_intro_new_subtitle3: "휴일을 숨겨 업무일에만 집중 ",
  basic_intro_new_text3: "달력 오른쪽 상단의 화살표를 클릭하고, 설정에서 \"고급 - 매주 휴일\"에서 휴일을 사용자 정의하고 표시 여부를 설정할 수 있습니다.",

  cata_basic_intro_new_title4: "행/열 수 사용자 정의",
  basic_intro_new_subtitle4: "행과 열 수를 조정하여 나만의 캘린더 뷰 작성",
  basic_intro_new_text4: "캘린더 오른쪽 상단의 화살표를 클릭하고, 설정에서 \"캘린더 - 표시\"에서 나타낼 행과 열 수를 사용자 정의할 수 있어 특정 주 또는 특정 요일만 표시 가능합니다.",

  cata_basic_intro_new_title5: "모든 시스템 지원",
  basic_intro_new_subtitle5: "Windows, Android, iOS, Mac, Linux 전부 지원",
  basic_intro_new_text5: "Android/iOS/Mac은 앱 스토어에서 \"CalendarTask\"을 검색하여 설치. <p/>Windows/Linux는<a href='/'>공식 웹사이트 홈페이지</a>에서 다운로드.",

  group_intro_title1: '일정을 쉽게 공유하세요',
  group_intro_subtitle1: '여러 명, 수십 명으로 구성된 소규모 팀이고 팀원들과 일정을 공유하고 관리하고 싶다면 CalendarTask의 팀 기능을 사용해 보세요.',
  group_intro_text1: '캘린더 오른쪽 상단에 있는 개인 버튼을 클릭한 다음 "계정 설정", "공유 팀"을 차례로 선택하고 마지막으로 페이지 오른쪽 상단에 구성원을 추가하세요. <p class="p" />관리를 용이하게 하기 위해 팀 구성원은 이메일을 통해서만 추가할 수 있습니다.',
  group_intro_title2: '팀원 일정은 공유되지 않습니다.',
  group_intro_subtitle2: '팀 구성원만이 자신의 작업과 일정을 보고 편집할 수 있으며, 팀 구성원은 서로 영향을 미치지 않습니다. ',
  group_intro_text2: '"계정 설정"에서 "하위 계정"을 클릭한 다음 하위 계정을 추가하세요. <p class="p" />그런 다음 "계정 설정"에서 "공유 팀"를 클릭하고 하위 계정 표시 컨트롤 바에서 팀 구성원에 해당하는 하위 계정을 선택하세요. ',
  group_intro_title3: '팀 구성원은 편집할 수 없습니다',
  group_intro_subtitle3: '일정을 공유하기만 하고 팀 구성원이 편집하는 것을 원하지 않는 경우 팀 구성원에 대해 읽기 전용으로 설정할 수 있습니다. ',
  group_intro_text3: '"계정 설정"에서"공유 팀"을 클릭하고 해당 구성원을 찾아 읽기 전용에 체크한 후 마지막으로 저장하세요. ',
  group_intro_title4: '모든 구성원의 일정을 편리하게 확인하세요',
  group_intro_subtitle4: '모든 구성원의 일정을 한눈에 볼 수 있습니다. ',
  group_intro_text4: '서브 계정 메뉴에서 \'메인 계정(멤버 전체 콘텐츠 표시)\' 선택<p class="p" />멤버의 표시 콘텐츠가 너무 많을 경우 해당 날짜로 마우스를 이동하면 완료됩니다. 프롬프트가 표시됩니다. ',

  cata_pay_new_upgrade_title: 'VIP 회원 기능',

  cata_pay_new_upgrade_title1: '멀티기기 실시간 싱크',
  pay_new_upgrade_title1: '실시간으로 데이터 자동 동기화',
  pay_new_upgrade_subtitle1: '휴대폰, 컴퓨터, iPad 등 다양한 기기에서 실시간 데이터 동기화 실현 가능',
  pay_new_upgrade_txt1: '동일한 계정으로 다른 기기에 로그인하기만 하면 데이터가 즉시 동기화되어 표시되며, 추가적인 처리가 필요하지 않습니다.',

  cata_pay_new_upgrade_title2: '이력 관리 기능',
  pay_new_upgrade_title2: '이력 관리 기능',
  pay_new_upgrade_subtitle2: '이력 자동 백업, 조회 및 삭제 가능 ',
  pay_new_upgrade_txt2: '데이터의 안전성을 보장하기 위해 서버에서도 이력을 동시에 백업합니다. 편집창을 열고 마지막 버튼을 클릭하면 모든 이력과 관련 기능을 확인할 수 있습니다.',

  cata_pay_new_upgrade_title3: '하위 계정 기능',
  pay_new_upgrade_title3: '하위 계정 기능',
  pay_new_upgrade_txt3: '데이터의 안전성을 보장하기 위해 서버에서도 이력을 동시에 백업합니다. 편집창을 열고 마지막 버튼을 클릭하면 모든 이력과 관련 기능을 확인할 수 있습니다.',
  pay_new_upgrade_subtitle3: '하루 동안 너무 많은 작업을 기록하면 작업, 생활 등의 분류에 따라 분리하여 표시할 수 있습니다.',

  cata_pay_new_upgrade_title4: '미완료 작업 자동 연기',
  pay_new_upgrade_title4: '미완료 작업 자동 연기',
  pay_new_upgrade_subtitle4: '하루에 너무 많은 작업을 기록하고 완료하지 못한 경우, 시스템은 자동으로 이 작업들을 다음 날로 연기',
  pay_new_upgrade_txt4: '자동 연기 기능은 최근 3일간의 미완료 작업을 다음 날로 연기하며, 작업이 연속으로 7일째 연기될 경우 이 기능은 자동으로 <p class="p" />연기된 작업 뒤에는 「(9-10)」이라는 표시가 추가되어 어느 달 며칠부터 연기된 것인지 나타냅니다. <p class="p" />완료 체크를 하면 해당 작업은 더 이상 자동으로 연기되지 않습니다.',

  cata_pay_new_upgrade_title5: '어디서나 로그',
  pay_new_upgrade_title5: '어디서나 로그',
  pay_new_upgrade_subtitle5: '집, 직장, 학교 등 어디서나 여러 대의 컴퓨터 간에 데이터를 즉시 동기화할 수 있습니다.',
  pay_new_upgrade_txt5: '',

  cata_pay_new_upgrade_title6: '로그인 기기 조회',
  pay_new_upgrade_title6: '로그인 기기 조회',
  pay_new_upgrade_subtitle6: '현재 로그인 된 단말기를 확인하고, 표시된 장치에서 로그아웃할 수 있습니다.',
  pay_new_upgrade_txt6: '「계정 설정」을 클릭한 다음, 「온라인 장치」를 선택하면 됩니다.',

  cata_pay_new_upgrade_title7: '로그인 기기 수량 제한 없음',
  pay_new_upgrade_title7: '로그인 기기 수량 제한 없음',
  pay_new_upgrade_subtitle7: '동일 계정으로 로그인할 수 있는 기기 수량에 제한이 없으며, 집, 회사 등 다양한 장소에서 로그인 가능',
  pay_new_upgrade_txt7: '일반 사용자는 2개의 단말기 로그인 제한이 적용됩니다.',

  cata_pay_new_upgrade_title8: '클라우드 영구 저장 데이터',
  pay_new_upgrade_title8: '클라우드 영구 저장 데이터',
  pay_new_upgrade_subtitle8: '회원 사용자 데이터는 클라우드에 영구적으로 저장되어 장치를 교체할 염려가 없습니다. 계정에 로그인하기만 하면 모든 데이터를 얻을 수 있습니다.',
  pay_new_upgrade_txt8: '무료 사용자 클라우드에는 최근 6개월의 데이터만 저장됩니다.',

  cata_pay_new_upgrade_title9: 'VIP 전용 고객센터',
  pay_new_upgrade_title9: 'VIP 전용 고객센터',
  pay_new_upgrade_subtitle9: '회원 이용 중 문제가 있으면 고객센터에 연락할 때 전속 고객센터에서 우선적으로 해결해 드립니다.',
  pay_new_upgrade_txt9: '',

  pay_payment_method: '지불',
  pay_payment_wechat: 'Wechat',
  pay_payment_paypal: 'PayPal',
  pay_upgrade_button: '지금 업그레이드',
  pay_upgrade_renew_button: '갱신',
  pay_forpay_left: '"',
  pay_forpay_right: '"지불하려면',
  pay_payment_unit: 'USD',
  pay_three_month: '3 개월',
  pay_one_year: '년',
  pay_three_year: '3 년',
  pay_original_price_threemonth: '4 USD',
  pay_original_price_oneyear: '16 USD',
  pay_original_price_threeyear: '48 USD',
  application: 'CalendarTask',

  cata_team_intro_title1: '당신의 일정을 쉽게 공유할 수 있습니다',
  cata_team_intro_title2: '팀원들의 일정을 확인하다',
  cata_team_intro_title3: '읽기 전용 권한',

  cata_user: '무료 사용자',
  cata_vip: 'VIP 회원 ',
  cata_vip_team: 'VIP 공유팀',

  group_upgrade_button: '팀 VIP 업그레이드',
  group_title: 'CalendarTask - 공유 팀',

  about_us: '',
  copy_right: 'Copyright © 2018 - 현재',

  wapper_title: "무료 배경화면 스킨",
  wapper_desc_html: "<p>Windows Store에서 다운로드한 설치 프로그램을 사용하고 있습니다. 권한 문제로 인해 배경화면 및 스킨 기능이 없습니다. </p><p class='red'>이 기능을 사용하려면 로그인 후 미리 동기화하세요. 데이터를 백업한 다음 Windows Store 버전을 제거하세요. <a href='/'>여기</a>에서 최신 설치 패키지를 다운로드하여 설치하세요 </p>",

  v2_slogan_text: "나만의 시간 관리 전문가",
  v2_feature_title: "투명 표시<span class=\"gap\">|</span>다중 기기 데이터 동기화<span class=\"gap\">|</span>메모<span class=\"gap\">|</span>카운트다운 기념일<span class=\"gap\">|</span>일정 알림",
  v2_feature_title_baseintro: "투명 표시<span class=\"gap\"></span>다중 기기 데이터 동기화<span class=\"gap\"></span>메모<span class=\"gap\"></span>카운트다운 기념일<span class=\"gap\"></span>일정 알림",
  v2_content_title_note: "메모",
  v2_content_title_noad: "광고 없음",
  v2_content_text_note: "체계적인 계획으로 더 효율적으로, 색상 자유 선택",
  v2_content_text_noad: "모든 채널에서 광고 없이 깨끗한 경험",

  v2_content_title_reminder: "알림",
  v2_content_text_reminder: "반복적이고 복잡한 작업 및 알림을 사용자 정의할 수 있습니다.",

  v2_content_title_countdown: "카운트다운 기념일 카드",
  v2_content_text_countdown: "바탕화면에 세련된 카드를 직접 표시하여 중요한 날을 잊지 않습니다.",

  v2_scan: "스캔",
  v2_down_phone: "앱 무료 다운로드",

  v2_update_time: "업데이트 시간",
  v2_update_ver: "최신 버전",
  v2_feature_other: "기타 기능",
  v2_feature_other_1_title: "개인화 설정",
  v2_feature_other_1_html: "<li>달력에 음력, 절기, 휴일, 공휴일 표시</li><li>원하는 날짜에 배경색 설정 가능</li><li>반복 작업 설정 (일, 주, 월, 년 단위)</li>",
  v2_feature_other_2_title: "스마트 기능",
  v2_feature_other_2_html: "<li>새 작업 추가는 엔터만 누르면 됨</li><li>플로팅 캘린더로 이번 주, 다음 주 작업 확인</li><li>작업 완료 시 자동으로 끝으로 이동</li><li>클라우드 자동 백업으로 기록 쉽게 확인</li><li>미완료 작업은 다음 날로 자동 연기</li>",
  v2_feature_other_3_title: "특별 기능",
  v2_feature_other_3_html: "<li>Excel로 내보내기 (PC 버전)</li><li>검색 기능으로 중요한 작업 빠르게 찾기</li><li>학습 주 설정 (교사 및 학생용)</li><li>서브 계정으로 업무와 학습 분리 기록</li><li>온라인 기기 확인 및 관리</li><li>소규모 팀 버전, 캘린더 공유 가능</li>",

  v2_about_us: "회사 소개",

  v2_feature_exclusive_text: "독점 기능",
  v2_feature_vip_text: "회원 기능",
  v2_feature_normal_text: "기본 기능",
  v2_feature_team_text: "팀 혜택",

  v2_ver_free_title: "무료 버전",
  v2_ver_free_desc: "개인 로컬 사용에 적합",
  v2_ver_vip_title: "개인 버전",
  v2_ver_vip_desc: "개인 사용에 적합, 다중 기기 동기화 가능",
  v2_ver_team_title: "팀 버전",
  v2_ver_team_desc: "중소규모 팀 협업에 적합",

  v2_ver_free_equity: "기본 기능",
  v2_ver_vip_equity: "회원 기능",
  v2_ver_team_equity: "팀 기능",
  v2_ver_equity_support: "지원",

  v2_ver_include_base: "기본 기능 포함",
  v2_ver_include_vip: "VIP 기능 포함",

  v2_down_btn_text: "무료 다운로드",

  v2_sub_title: "미루지 말고 효율적인 삶",
  v2_www_link: "공식 홈페이지",
  v2_pay_btn_text: "지금 업그레이드",
  v2_team_days_desc: "연간 10인",
  v2_team_btn: "팀 버전 보기"

};
exports["default"] = ko_Kr;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./lang/ko_Kr.js
// module id = 303
// module chunks = 0